import * as React from 'react';
import * as ReactDOM from 'react-dom';
import * as classNames from 'classnames';

import * as Markdown from 'markdown-it';
import * as MarkdownSub from 'markdown-it-sub';
import * as MarkdownSup from 'markdown-it-sup';
import * as MarkdownMathJax from 'markdown-it-mathjax';
import * as MarkdownUnderline from 'markdown-it-underline';
import * as MarkdownContainer from 'markdown-it-container';
import * as MarkdownLinkAttributes from 'markdown-it-link-attributes';
const md = (Markdown as any)({typographer: true})
  .use(MarkdownLinkAttributes, {
    attrs: {target: '_blank'},
  })
  .use(MarkdownContainer, 'image-wrapper')
  .use(MarkdownContainer, 'variable')
  .use(MarkdownContainer, 'variable-inline')
  .use(MarkdownContainer, 'display-inline')
  .use(MarkdownContainer, 'table--bordered')
  .use(MarkdownContainer, 'hints-wrap')
  .use(MarkdownContainer, 'detailed-hints-wrap')
  .use((MarkdownMathJax as any)())
  .use(MarkdownUnderline)
  .use(MarkdownSub)
  .use(MarkdownSup);

// configure highlight
import * as Highlight from 'highlight.js/lib/highlight.js';
import * as LanguageJavascript from 'highlight.js/lib/languages/javascript';
import * as LanguageCss from 'highlight.js/lib/languages/css';
import * as LanguageHtml from 'highlight.js/lib/languages/xml';
import LanguagePramp from './language-pramp';
import isString = require('lodash/isString');
Highlight.registerLanguage('pramp', LanguagePramp);
Highlight.registerLanguage('css', LanguageCss);
Highlight.registerLanguage('javascript', LanguageJavascript);
Highlight.registerLanguage('html', LanguageHtml);
Highlight.configure({
  tabReplace: '  ',
});

import 'highlight.js/styles/atom-one-light.css';
import './styles/highlight.sass';
import {WHITE_LABEL} from '../../utils/config';

interface IProps {
  children?: any;
  isActive?: boolean;
  markdown: boolean;
  title: string;
}

const blueExperimentEnabled = WHITE_LABEL === 'blue';
const greenExperimentEnabled = WHITE_LABEL === 'green';
const cyanExperimentEnabled = WHITE_LABEL === 'cyan';
export class NavTabPanel extends React.Component<IProps, any> {
  public static mathJaxLoaded: boolean = false;

  public render(): React.ReactElement<any> {
    const {markdown, isActive, children} = this.props;
    const panelClassNames = classNames('nav-tab-panel', {
      'nav-tab-panel_active': isActive,
      'nav-tab-panel_markdown': markdown,
      'nav-tab-panel_whitelabel_blue': blueExperimentEnabled,
      'nav-tab-panel_whitelabel_green': greenExperimentEnabled,
      'nav-tab-panel_whitelabel_cyan': cyanExperimentEnabled,
    });

    const content = this.isText()
      ? <div className={panelClassNames} dangerouslySetInnerHTML={{__html: this.html()}} />
      : <div className={panelClassNames}>{children}</div>;

    return content;
  }

  public componentDidMount(): void {
    this.loadMathJax();
    this.highlight();
  }

  public componentDidUpdate(): void {
    this.highlight();
  }

  private isText(): boolean {
    return this.props.markdown || isString(this.props.children);
  }

  private html(): string {
    const {markdown, children} = this.props;

    if (markdown) {
      return md.render(children);
    }

    return children;
  }

  private loadMathJax(): void {
    if (!NavTabPanel.mathJaxLoaded) {
      NavTabPanel.mathJaxLoaded = true;

      const script = document.createElement('script');
      script.src = 'https://cdnjs.cloudflare.com/ajax/libs/mathjax/2.7.0/MathJax.js?config=TeX-MML-AM_CHTML';
      script.async = true;
      script.defer = true;

      document.body.appendChild(script);
    }
  }

  private highlight(): void {
    const element = ReactDOM.findDOMNode(this);

    for (let node of element.querySelectorAll('pre code')) {
      if (!node.className.includes('hljs')) {
        Highlight.highlightBlock(node);
      }
    }
  }
}
